import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  CampaignLogsQuerySchema,
  CampaignLogsResponseDataSchema,
  DataResponseWithPagination,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof CampaignLogsQuerySchema>
type Response = DataResponseWithPagination<z.infer<typeof CampaignLogsResponseDataSchema>>

type Props = {
  id: string
  query: Query
  onSuccess?: (data: Response) => void
}

const getCampaignQueryKey = (props: Props) => ["campaigns", "logs", JSON.stringify(props)]

export const campaignLogsQuery = (props: Props) => {
  const { id, query, onSuccess } = props

  return queryOptions({
    queryKey: getCampaignQueryKey(props),
    queryFn: async () => {
      const response = await axios.get<Response>(`/campaigns/${id}/logs`, {
        params: query,
      })

      onSuccess?.(response.data)

      return response.data.data
    },
  })
}
